import React from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { AUTH_STATES } from '../../../constants/authConsts';
import { RouteContext } from '../../../context';
import { OnboardingAuth } from './OnboardingAuth';
import { OnboardingForgotPasswordPage } from './OnboardingForgotPasswordPage';
import { queryParams } from './OnboardingLoginPage';
import { OnboardingRegisterPage } from './OnboardingRegisterPage';

export type OnboardingAuthLayoutProps = {
  onAuthComplete: () => void;
};

interface MfaVerificationData {
  user: CognitoUser;
  email: string;
}

export const OnboardingAuthLayout = ({
  onAuthComplete,
}: OnboardingAuthLayoutProps) => {
  const { query }: { query: queryParams } = React.useContext(RouteContext);
  const { step } = query || '';

  // const navigateToLogin = () => {
  //   let loginPath = '/login';
  //   if (query.email) {
  //     loginPath = `${loginPath}?email=${encodeURIComponent(query.email)}`;
  //   }

  //   history.push(loginPath);
  // };

  // const authListenerHandler = data => {
  //   if (
  //     data &&
  //     data.payload &&
  //     data.payload.data &&
  //     data.payload.data.message
  //   ) {
  //     if (data.payload.event === 'signIn_failure') {
  //       // TODO:// Show alert message for sign in failure reason
  //       // if the email and password provided in query are incorrect
  //       // navigate user to login form
  //       navigateToLogin();
  //     }
  //   }
  // };

  // React.useEffect(() => {
  //   // Listen for the auth errors
  //   // Errors come inside `data.payload.data.message`
  //   Hub.listen('auth', authListenerHandler);

  //   return () => {
  //     Hub.remove('auth', authListenerHandler);
  //   };
  // }, []);

  const renderRegisterForm = query.auth && step === AUTH_STATES.SIGN_IN;
  const renderForgotPasswordForm = step === AUTH_STATES.FORGOT_PASSWORD;

  // this is used to store the user  being signed in
  // when an mfa challenge is required
  const [mfaData, setMfaData] = React.useState<MfaVerificationData>();

  const renderAuthForm = React.useCallback(() => {
    if (query && step) {
      if (renderRegisterForm) {
        return <OnboardingRegisterPage onAuthComplete={onAuthComplete} />;
      }

      // when mfa data is set, we want the user to complete the mfa challenge and
      // log in. This is done by calling the OnboardingAuth with the user and
      // setting the challenge type to be mfa
      if (mfaData) {
        return (
          <OnboardingAuth
            user={mfaData.user}
            mfaChallengeParam={{
              type: 'SOFTWARE_TOKEN_MFA',
              email: mfaData.email,
              ...mfaData.user.challegeParam,
            }}
            onAuthComplete={onAuthComplete}
          />
        );
      }

      if (renderForgotPasswordForm) {
        return (
          // onAuthComplete is invoked when the user has mfa disabled
          // When mfa is enabled, onMfaRequired with the data of user trying to
          // sign in
          // This data is set in the mfaData which renders the OnboardingAuth component,
          // which takes care of completing the challenge and signing in the user
          <OnboardingForgotPasswordPage
            onAuthComplete={onAuthComplete}
            onMfaRequired={(user, email) => {
              // when mfa is required, the user is stored to
              // confirm signing in later
              setMfaData({ user, email });
            }}
          />
        );
      }
    }

    return <OnboardingAuth onAuthComplete={onAuthComplete} />;
  }, [renderRegisterForm, renderForgotPasswordForm, query, mfaData]);

  return <>{renderAuthForm()}</>;
};
